import classNames from 'classnames';
import { map } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { trackEvent } from '../../../react/services/Tracking';
import styles from './style.m.less';

let nameCounter = 0;
const getName = (name = '') => `horizontalradio-${name && name.length ? name : nameCounter++}`;

function HorizontalRadio({ value, options, onChange, name, className, small = true, eventTracking, onClear }) {
    const inputName = getName(name);
    return (
        <div className={classNames(className, 'horizontal-radio', { small, [styles.clearable]: !!onClear })}>
            {map(option => {
                const id = `${inputName}-${option.value}`;
                return (
                    <Fragment key={option.value}>
                        <input
                            id={id}
                            name={inputName}
                            disabled={option.disabled}
                            type="radio"
                            checked={value === option.value}
                            onChange={() => {
                                if (eventTracking) {
                                    trackEvent({ ...eventTracking, label: option.trackingLabel });
                                }
                                if (option.value !== value) {
                                    onChange(option.value);
                                }
                            }}
                            onClick={onClear && option.value === value ? onClear : undefined}
                        />
                        <label
                            htmlFor={id}
                            title={option.title}
                            className={classNames(styles.label, {
                                [styles.smallLabel]: small,
                                [styles.regularLabel]: !small,
                            })}
                        >
                            {option.label}
                        </label>
                    </Fragment>
                );
            }, options)}
        </div>
    );
}

HorizontalRadio.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
            label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
            trackingLabel: PropTypes.string,
            disabled: PropTypes.bool,
        })
    ),
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string,
    className: PropTypes.string,
    small: PropTypes.bool,
    eventTracking: PropTypes.shape({
        category: PropTypes.string.isRequired,
        action: PropTypes.string.isRequired,
    }),
    onClear: PropTypes.func,
};

export default HorizontalRadio;
